import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface RemoveTagFromParentResponse {
  tags: Array<Tag>;
}

export interface Tag {
  _id: string;
  fieldName: string;
}

export interface RemoveTagFromParentParams {
  parentId: string;
  tagIds: Array<string>;
}

export const removeTagFromParentAPI = async ({
  parentId,
  tagIds,
}: RemoveTagFromParentParams) => {
  const resp = await baseAPI.delete<RemoveTagFromParentResponse>(
    `/parents/${parentId}/tags`,
    {
      data: {
        tagIds,
      },
    },
  );
  return resp.data;
};

export const useRemoveTagFromParentMutation = () => {
  return useMutation({
    mutationFn: async (params: RemoveTagFromParentParams) => {
      const response = await removeTagFromParentAPI(params);
      return response;
    },
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENT_TAGS, params.parentId],
      });
    },
  });
};
